// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DatabaseFilledSvg from "@fishx/icons-svg/es/asn/DatabaseFilled";
import FishxIcon from '../components/FishxIcon';

var DatabaseFilled = function DatabaseFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DatabaseFilledSvg
  }));
};

DatabaseFilled.displayName = 'DatabaseFilled';
export default React.forwardRef(DatabaseFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DatabaseFilled.js
// module id = 2373
// module chunks = 0